import { getSubSteps } from '#models/general/steps';

import { getMainInfoFields } from './mainInfo';
import { getInitialPageFields } from './initialPage';

export const FEINTS_SUBSTEP_TARGET = 'AdelphiFeintModal';

export const FEINTS_SUBSTEPS_IDS = {
  INITIAL_PAGE: 'initialPage',
  MAIN_INFORMATION: 'mainInformation'
};

const FEINTS_NEXT_SUBSTEPS = {
  [FEINTS_SUBSTEPS_IDS.INITIAL_PAGE]: FEINTS_SUBSTEPS_IDS.MAIN_INFORMATION
};

const FEINTS_PREVIOUS_SUBSTEPS = {
  [FEINTS_SUBSTEPS_IDS.MAIN_INFORMATION]: FEINTS_SUBSTEPS_IDS.INITIAL_PAGE
};

export const FEINTS_SUBSTEPS = getSubSteps(
  FEINTS_SUBSTEP_TARGET,
  FEINTS_SUBSTEPS_IDS,
  FEINTS_NEXT_SUBSTEPS,
  FEINTS_PREVIOUS_SUBSTEPS
);

export const FEINTS_COMPLETE_FIELDS = {
  [FEINTS_SUBSTEPS_IDS.INITIAL_PAGE]: getInitialPageFields,
  [FEINTS_SUBSTEPS_IDS.MAIN_INFORMATION]: getMainInfoFields
};

export const FEINTS_SUBSTEPS_ADDITION_PROPS = {
  [FEINTS_SUBSTEPS_IDS.INITIAL_PAGE]: {
    oneColumnForm: true
  },
  [FEINTS_SUBSTEPS_IDS.MAIN_INFORMATION]: {
    oneColumnForm: true
  }
};

export const ADELPHI_FEINTS_SUBSTEPS_INFO = {
  target: FEINTS_SUBSTEP_TARGET,
  substeps: FEINTS_SUBSTEPS,
  fields: FEINTS_COMPLETE_FIELDS,
  additionalProps: FEINTS_SUBSTEPS_ADDITION_PROPS
};

export const FEINT_INITIAL_PAGE_FIELDS = {
  PERIOD_ID: 'periodId',
  DATE: 'date',
  OPERATOR: 'operator'
};

export const FEINT_MAIN_INFO_FIELDS = {
  FEINT_TYPE: 'feintType',
  DIP: 'dip',
  BULK: 'bulk',
  TEMP: 'temp',
  IND: 'ind',
  STRENGTH: 'strength',
  TCF: 'tcf',
  CBULK: 'cbulk',
  LALC: 'lalc'
};
